import { combineEpics } from 'redux-observable';
import { preSSOEpic, fetchSSOEndpointEpic } from './preSSOEpics';
import { postSSOEpic, loginToCommandCenterEpic } from './postSSOEpics';

export default combineEpics(
  preSSOEpic,
  postSSOEpic,
  fetchSSOEndpointEpic,
  loginToCommandCenterEpic
);



// WEBPACK FOOTER //
// ./src/epics/index.js